module.exports = __webpack_public_path__ + "img/node.00c5c8d8.png";